import { render, staticRenderFns } from "./BlogPosts.vue?vue&type=template&id=3b4e330d&scoped=true&"
import script from "./BlogPosts.vue?vue&type=script&lang=js&"
export * from "./BlogPosts.vue?vue&type=script&lang=js&"
import style0 from "./BlogPosts.vue?vue&type=style&index=0&id=3b4e330d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4e330d",
  null
  
)

export default component.exports